import React from 'react'
import LoginOtpPage from './LoginOtpPage'

export * from './LoginOtpPage'
export default React.memo(LoginOtpPage)
